// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"components_searchForm__2DkQJ","statisticsCard":"components_statisticsCard__vqy2w"};